<template>
  <div class="production-car-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-content">
        <div class="header-icon">
          <i class="el-icon-s-data"></i>
        </div>
        <div class="header-text">
          <h2>生产车辆记录</h2>
          <p class="subtitle">根据车辆关系表统计挖机和自卸车的车数</p>
        </div>
      </div>
    </div>

    <!-- 筛选条件 -->
    <div class="filter-section">
      <el-card class="filter-card" shadow="hover">
        <div class="filter-content">
          <el-form :model="filterForm" inline class="filter-form">
            <el-form-item label="日期范围" class="filter-item">
              <el-date-picker
                v-model="filterForm.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="handleFilterChange"
                class="filter-date"
              />
            </el-form-item>
            <el-form-item label="班次类型" class="filter-item">
              <el-select
                v-model="filterForm.shiftType"
                placeholder="请选择班次"
                clearable
                @change="handleFilterChange"
                class="filter-select"
              >
                <el-option label="早班" value="MORNING" />
                <el-option label="夜班" value="NIGHT" />
              </el-select>
            </el-form-item>
            <el-form-item label="挖机编号" class="filter-item">
              <el-input
                v-model="filterForm.excavatorNumber"
                placeholder="请输入挖机编号"
                clearable
                @input="handleFilterChange"
                class="filter-input"
              />
            </el-form-item>
            <el-form-item label="自卸车编号" class="filter-item">
              <el-input
                v-model="filterForm.truckNumber"
                placeholder="请输入自卸车编号"
                clearable
                @input="handleFilterChange"
                class="filter-input"
              />
            </el-form-item>
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
              <el-button @click="handleReset" class="reset-btn">
                <i class="el-icon-refresh"></i>
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-section">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="stats-card excavator-card" shadow="hover">
            <div class="stats-content">
              <div class="stats-icon">
                <i class="el-icon-truck"></i>
              </div>
              <div class="stats-info">
                <div class="stats-number">{{ stats.totalExcavators }}</div>
                <div class="stats-label">挖机总数</div>
                <div class="stats-trend">
                  <i class="el-icon-arrow-up"></i>
                  <span>总车数: {{ stats.totalExcavatorCount || 0 }}</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card truck-card" shadow="hover">
            <div class="stats-content">
              <div class="stats-icon">
                <i class="el-icon-truck"></i>
              </div>
              <div class="stats-info">
                <div class="stats-number">{{ stats.totalTrucks }}</div>
                <div class="stats-label">自卸车总数</div>
                <div class="stats-trend">
                  <i class="el-icon-arrow-up"></i>
                  <span>较昨日 +5</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card count-card" shadow="hover">
            <div class="stats-content">
              <div class="stats-icon">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="stats-info">
                <div class="stats-number">{{ stats.totalCarCount }}</div>
                <div class="stats-label">总车数</div>
                <div class="stats-trend">
                  <i class="el-icon-arrow-up"></i>
                  <span>较昨日 +12</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card avg-card" shadow="hover">
            <div class="stats-content">
              <div class="stats-icon">
                <i class="el-icon-date"></i>
              </div>
              <div class="stats-info">
                <div class="stats-number">{{ stats.avgCarCount }}</div>
                <div class="stats-label">日均车数</div>
                <div class="stats-trend">
                  <i class="el-icon-arrow-up"></i>
                  <span>较昨日 +3</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 数据表格 -->
    <div class="table-section">
      <el-card class="table-card" shadow="hover">
        <div slot="header" class="table-header">
          <div class="header-left">
            <div class="header-icon-wrapper">
              <i class="el-icon-s-data"></i>
            </div>
            <div class="header-text-wrapper">
              <span class="header-title">生产车辆记录</span>
              <el-tag type="info" size="small" class="data-count">
                共 {{ pagination.total }} 条记录
              </el-tag>
            </div>
          </div>
          <div class="header-actions">
            <el-button type="success" @click="handleExport" class="action-btn export-btn">
              <i class="el-icon-download"></i>
              导出数据
            </el-button>
            <el-button type="primary" @click="handleRefresh" class="action-btn refresh-btn">
              <i class="el-icon-refresh"></i>
              刷新数据
            </el-button>
          </div>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          :span-method="objectSpanMethod"
          class="custom-table"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="excavatorNumber" label="挖机编号" width="140" align="center">
            <template slot-scope="scope">
              <div class="vehicle-number">
                <div class="vehicle-icon">
                  <i class="el-icon-truck"></i>
                </div>
                <div class="vehicle-info">
                  <span class="vehicle-text">{{ scope.row.excavatorNumber }}</span>
                  <span class="vehicle-total">总车数: {{ scope.row.excavatorTotalCount }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="excavatorName" label="挖机司机" width="140" align="center">
            <template slot-scope="scope">
              <div class="driver-info">
                <div class="driver-avatar">
                  <i class="el-icon-user"></i>
                </div>
                <span class="driver-name">{{ scope.row.excavatorName || '待分配' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="truckNumber" label="自卸车编号" width="140" align="center">
            <template slot-scope="scope">
              <div class="vehicle-number">
                <div class="vehicle-icon truck-icon">
                  <i class="el-icon-truck"></i>
                </div>
                <div class="vehicle-info">
                  <span class="vehicle-text">{{ scope.row.truckNumber }}</span>
                  <span class="vehicle-total">车数: {{ scope.row.truckCount }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="truckName" label="自卸车司机" width="140" align="center">
            <template slot-scope="scope">
              <div class="driver-info">
                <div class="driver-avatar">
                  <i class="el-icon-user"></i>
                </div>
                <span class="driver-name">{{ scope.row.truckName || '待分配' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="shiftType" label="班次" width="100" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="getShiftTypeTagType(scope.row.shiftType)"
                size="small"
                class="shift-tag"
                effect="dark"
              >
                {{ getShiftTypeText(scope.row.shiftType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="carCount" label="车数" width="100" align="center">
            <template slot-scope="scope">
              <div class="car-count">
                <div class="count-circle">
                  <span class="count-number">{{ scope.row.carCount || 0 }}</span>
                </div>
                <span class="count-unit">车</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="recordDate" label="记录日期" width="140" align="center">
            <template slot-scope="scope">
              <div class="date-info">
                <div class="date-icon">
                  <i class="el-icon-date"></i>
                </div>
                <span class="date-text">{{ formatDate(scope.row.recordDate) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 1 ? 'success' : 'danger'"
                size="small"
                effect="dark"
                class="status-tag"
              >
                <i :class="scope.row.status === 1 ? 'el-icon-check' : 'el-icon-close'"></i>
                {{ scope.row.status === 1 ? '正常' : '异常' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" fixed="right" align="center">
            <template slot-scope="scope">
              <div class="action-buttons">
                <el-button type="primary" size="mini" @click="handleEdit(scope.row)" class="edit-btn">
                  <i class="el-icon-edit"></i>
                  编辑
                </el-button>
                <el-button type="danger" size="mini" @click="handleDelete(scope.row)" class="delete-btn">
                  <i class="el-icon-delete"></i>
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            background
            class="custom-pagination"
          />
        </div>
      </el-card>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editDialog.title"
      :visible.sync="editDialog.visible"
      width="600px"
      :close-on-click-modal="false"
      class="custom-dialog"
    >
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="120px" class="edit-form">
        <el-form-item label="挖机" prop="excavatorId">
          <el-select
            v-model="editForm.excavatorId"
            placeholder="请选择挖机"
            filterable
            @change="handleExcavatorChange"
            class="full-width"
          >
            <el-option
              v-for="item in excavatorList"
              :key="item.id"
              :label="`${item.vehicleNumber} - ${item.name}`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="自卸车" prop="truckId">
          <el-select
            v-model="editForm.truckId"
            placeholder="请选择自卸车"
            filterable
            class="full-width"
          >
            <el-option
              v-for="item in truckList"
              :key="item.id"
              :label="`${item.vehicleNumber} - ${item.name}`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="班次类型" prop="shiftType">
          <el-select v-model="editForm.shiftType" placeholder="请选择班次" class="full-width">
            <el-option label="早班" value="MORNING" />
            <el-option label="夜班" value="NIGHT" />
          </el-select>
        </el-form-item>
        <el-form-item label="车数" prop="carCount">
          <el-input-number
            v-model="editForm.carCount"
            :min="0"
            :max="999"
            class="full-width"
            placeholder="请输入车数"
          />
        </el-form-item>
        <el-form-item label="记录日期" prop="recordDate">
          <el-date-picker
            v-model="editForm.recordDate"
            type="date"
            placeholder="请选择记录日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            class="full-width"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="editForm.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog.visible = false" class="cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleSave" :loading="saving" class="save-btn">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  getVehicleRelationRecords, 
  getStats, 
  getExcavatorList, 
  getTruckList, 
  exportVehicleRelationData,
  editVehicleRelationRecord,
  deleteVehicleRelationRecord
} from '@/api/production'

export default {
  name: 'ProductionCar',
  data() {
    return {
      loading: false,
      saving: false,

      // 筛选表单
      filterForm: {
        dateRange: this.getDefaultDateRange(),
        shiftType: '',
        excavatorNumber: '',
        truckNumber: ''
      },

      // 统计数据
      stats: {
        totalExcavators: 0,
        totalTrucks: 0,
        totalCarCount: 0,
        avgCarCount: 0
      },

      // 分页
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },

      // 表格数据
      tableData: [],
      spanData: [],

      // 车辆列表
      excavatorList: [],
      truckList: [],

      // 编辑弹窗
      editDialog: {
        visible: false,
        title: '编辑车数记录'
      },

      editForm: {
        id: null,
        excavatorId: null,
        truckId: null,
        shiftType: '',
        carCount: 0,
        recordDate: '',
        status: 1
      },

      editRules: {
        excavatorId: [{ required: true, message: '请选择挖机', trigger: 'change' }],
        truckId: [{ required: true, message: '请选择自卸车', trigger: 'change' }],
        shiftType: [{ required: true, message: '请选择班次', trigger: 'change' }],
        carCount: [{ required: true, message: '请输入车数', trigger: 'blur' }],
        recordDate: [{ required: true, message: '请选择记录日期', trigger: 'change' }]
      }
    }
  },

  mounted() {
    this.loadData()
    this.loadVehicleList()
    this.loadStats()
  },

  methods: {
    // 获取默认日期范围：前一天6点到今天6点
    getDefaultDateRange() {
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(today.getDate() - 1)
      
      // 格式化日期为 yyyy-MM-dd 格式
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      
      // 前一天6点到今天6点的日期范围
      // 由于日期选择器只能选择日期，我们选择前一天到今天
      // 实际的时间范围是：前一天 06:00:00 到 今天 06:00:00
      return [formatDate(yesterday), formatDate(today)]
    },

    // 表格头部样式
    headerCellStyle() {
      return {
        backgroundColor: '#f8f9fa',
        color: '#495057',
        fontWeight: '600',
        fontSize: '14px',
        borderBottom: '2px solid #dee2e6'
      }
    },

    // 表格单元格样式
    cellStyle() {
      return {
        fontSize: '13px',
        padding: '8px 0'
      }
    },

    async loadData() {
      this.loading = true
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size
        }

        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          // 添加时间信息：开始日期为 06:00:00，结束日期为 06:00:00
          params.startDate = this.filterForm.dateRange[0] + ' 06:00:00'
          params.endDate = this.filterForm.dateRange[1] + ' 06:00:00'
        }

        if (this.filterForm.shiftType) {
          params.shiftType = this.filterForm.shiftType
        }

        if (this.filterForm.excavatorNumber) {
          params.excavatorNumber = this.filterForm.excavatorNumber
        }

        if (this.filterForm.truckNumber) {
          params.truckNumber = this.filterForm.truckNumber
        }

        const response = await getVehicleRelationRecords(params)

        if (response.code === 200) {
          // 处理新的数据结构，将嵌套的trucks数据展平
          this.tableData = this.flattenVehicleData(response.data || [])
          this.pagination.total = this.tableData.length
          this.calculateSpanData()
        } else {
          this.$message.error(response.msg || '加载数据失败')
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },

    // 将嵌套的车辆数据展平为表格数据
    flattenVehicleData(data) {
      const flattenedData = []
      
      data.forEach(excavatorGroup => {
        excavatorGroup.trucks.forEach(truck => {
          flattenedData.push({
            id: `${excavatorGroup.excavatorId}_${truck.truckId}`,
            excavatorId: excavatorGroup.excavatorId,
            excavatorNumber: excavatorGroup.excavatorNumber,
            excavatorName: excavatorGroup.excavatorName,
            excavatorTotalCount: excavatorGroup.excavatorTotalCount,
            truckId: truck.truckId,
            truckNumber: truck.truckNumber,
            truckName: truck.truckName,
            truckCount: truck.truckCount,
            shiftType: excavatorGroup.shiftType,
            carCount: truck.truckCount, // 车数就是truckCount
            recordDate: this.getCurrentDate(),
            status: truck.truckCount > 0 ? 1 : 0 // 有车数则为正常状态
          })
        })
      })
      
      return flattenedData
    },

    // 获取当前日期
    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    async loadStats() {
      try {
        const params = {}
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          // 添加时间信息：开始日期为 06:00:00，结束日期为 06:00:00
          params.startDate = this.filterForm.dateRange[0] + ' 06:00:00'
          params.endDate = this.filterForm.dateRange[1] + ' 06:00:00'
        }

        const response = await getStats(params)

        if (response.code === 200) {
          this.stats = response.data || this.stats
        } else {
          // 如果统计接口不可用，从表格数据计算统计信息
          this.calculateStatsFromTableData()
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
        // 从表格数据计算统计信息
        this.calculateStatsFromTableData()
      }
    },

    // 从表格数据计算统计信息
    calculateStatsFromTableData() {
      const excavatorSet = new Set()
      const truckSet = new Set()
      let totalCarCount = 0
      let totalExcavatorCount = 0

      this.tableData.forEach(item => {
        excavatorSet.add(item.excavatorId)
        truckSet.add(item.truckId)
        totalCarCount += item.carCount || 0
        totalExcavatorCount += item.excavatorTotalCount || 0
      })

      this.stats = {
        totalExcavators: excavatorSet.size,
        totalTrucks: truckSet.size,
        totalCarCount: totalCarCount,
        totalExcavatorCount: totalExcavatorCount,
        avgCarCount: this.tableData.length > 0 ? Math.round(totalCarCount / this.tableData.length) : 0
      }
    },

    async loadVehicleList() {
      try {
        const excavatorResponse = await getExcavatorList()

        if (excavatorResponse.code === 200) {
          this.excavatorList = excavatorResponse.data || []
        }

        const truckResponse = await getTruckList()

        if (truckResponse.code === 200) {
          this.truckList = truckResponse.data || []
        }
      } catch (error) {
        console.error('加载车辆列表失败:', error)
        this.$message.error('加载车辆列表失败')
      }
    },

    // 计算合并单元格数据
    calculateSpanData() {
      this.spanData = []
      let pos = 0

      for (let i = 0; i < this.tableData.length; i++) {
        if (i === 0) {
          this.spanData.push(1)
          pos = 0
          continue
        }

        // 如果当前行与上一行的挖机编号相同，则合并
        if (this.tableData[i].excavatorNumber === this.tableData[i - 1].excavatorNumber) {
          this.spanData[pos] += 1
          this.spanData.push(0)
        } else {
          this.spanData.push(1)
          pos = i
        }
      }
    },

    // 合并单元格方法
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) { // 挖机编号和挖机司机列
        const _row = this.spanData[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },

    // 获取班次类型标签样式
    getShiftTypeTagType(shiftType) {
      const typeMap = {
        'MORNING': 'success',
        'AFTERNOON': 'warning',
        'NIGHT': 'info',
        'ALL_DAY': 'primary'
      }
      return typeMap[shiftType] || 'info'
    },

    // 获取班次类型文本
    getShiftTypeText(shiftType) {
      const textMap = {
        'MORNING': '早班',
        'NIGHT': '夜班',
      }
      return textMap[shiftType] || shiftType
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString()
    },

    handleFilterChange() {
      this.pagination.current = 1
      this.loadData()
      this.loadStats()
    },

    handleSearch() {
      this.pagination.current = 1
      this.loadData()
      this.loadStats()
    },

    handleReset() {
      this.filterForm = {
        dateRange: this.getDefaultDateRange(),
        shiftType: '',
        excavatorNumber: '',
        truckNumber: ''
      }
      this.pagination.current = 1
      this.loadData()
      this.loadStats()
    },

    handleSizeChange(size) {
      this.pagination.size = size
      this.loadData()
    },

    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadData()
    },

    handleRefresh() {
      this.loadData()
      this.loadStats()
    },

    async handleExport() {
      try {
        const params = { ...this.filterForm }
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          // 添加时间信息：开始日期为 06:00:00，结束日期为 06:00:00
          params.startDate = this.filterForm.dateRange[0] + ' 06:00:00'
          params.endDate = this.filterForm.dateRange[1] + ' 06:00:00'
        }

        const response = await exportVehicleRelationData(params)

        // 创建下载链接
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '生产车辆记录.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)

        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败')
      }
    },

    handleEdit(row) {
      this.editDialog.title = '编辑车数记录'
      this.editForm = {
        id: row.id,
        excavatorId: row.excavatorId,
        truckId: row.truckId,
        shiftType: row.shiftType,
        carCount: row.carCount,
        recordDate: row.recordDate,
        status: row.status
      }
      this.editDialog.visible = true
    },

    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这条记录吗？', '提示', {
          type: 'warning'
        })

        const response = await deleteVehicleRelationRecord(row.id)

        if (response.code === 200) {
          this.$message.success('删除成功')
          this.loadData()
          this.loadStats()
        } else {
          this.$message.error(response.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }
    },

    async handleSave() {
      try {
        await this.$refs.editFormRef.validate()
        this.saving = true

        const response = await editVehicleRelationRecord(this.editForm)

        if (response.code === 200) {
          this.$message.success('保存成功')
          this.editDialog.visible = false
          this.loadData()
          this.loadStats()
        } else {
          this.$message.error(response.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },

    handleExcavatorChange() {
      this.editForm.truckId = null
    }
  }
}
</script>

<style scoped>
.production-car-container {
  padding: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.page-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.header-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  color: white;
  font-size: 24px;
}

.header-text h2 {
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 700;
}

.subtitle {
  color: #7f8c8d;
  margin: 0;
  font-size: 16px;
  font-weight: 400;
}

.filter-section {
  margin-bottom: 24px;
}

.filter-card {
  border-radius: 16px;
  border: none;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.filter-content {
  padding: 24px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.filter-item {
  margin-bottom: 0;
}

.filter-item >>> .el-form-item__label {
  color: #2c3e50;
  font-weight: 600;
  font-size: 14px;
}

.filter-date,
.filter-select,
.filter-input {
  width: 200px;
}

.filter-date {
  width: 280px;
}

.filter-date >>> .el-input__inner,
.filter-select >>> .el-input__inner,
.filter-input >>> .el-input__inner {
  border-radius: 8px;
  border: 2px solid #e1e8ed;
  transition: all 0.3s ease;
}

.filter-date >>> .el-range-input {
  width: 42%;
  text-align: center;
}

.filter-date >>> .el-range-separator {
  padding: 0 8px;
  color: #606266;
  font-weight: 500;
  min-width: 25px;
  text-align: center;
  display: inline-block;
  font-size: 12px;
}

.filter-date >>> .el-input__inner:focus,
.filter-select >>> .el-input__inner:focus,
.filter-input >>> .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.filter-actions {
  margin-bottom: 0;
}

.search-btn,
.reset-btn {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

.search-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
}

.search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}

.reset-btn {
  background: #f8f9fa;
  border: 2px solid #e1e8ed;
  color: #6c757d;
}

.reset-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  transform: translateY(-2px);
}

.stats-section {
  margin-bottom: 24px;
}

.stats-card {
  border-radius: 16px;
  border: none;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  overflow: hidden;
}

.stats-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.15);
}

.stats-content {
  display: flex;
  align-items: center;
  padding: 24px;
  position: relative;
}

.stats-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 24px;
  color: white;
}

.excavator-card .stats-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.truck-card .stats-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.count-card .stats-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.avg-card .stats-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stats-info {
  flex: 1;
}

.stats-number {
  font-size: 32px;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 8px;
  line-height: 1;
}

.stats-label {
  font-size: 16px;
  color: #7f8c8d;
  font-weight: 500;
  margin-bottom: 8px;
}

.stats-trend {
  font-size: 12px;
  color: #27ae60;
  display: flex;
  align-items: center;
  gap: 4px;
}

.stats-trend i {
  font-size: 10px;
}

.table-section {
  margin-bottom: 24px;
}

.table-card {
  border-radius: 16px;
  border: none;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.header-text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-title {
  font-weight: 700;
  color: #2c3e50;
  font-size: 18px;
}

.data-count {
  background: #e3f2fd;
  color: #1976d2;
  border: none;
  font-size: 12px;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.export-btn {
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
  border: none;
  color: white;
}

.export-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(39, 174, 96, 0.3);
}

.refresh-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
}

.refresh-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}

.custom-table {
  border-radius: 12px;
  overflow: hidden;
}

.custom-table >>> .el-table__header-wrapper {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.custom-table >>> .el-table__body-wrapper {
  background: #fff;
}

.vehicle-number {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vehicle-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.vehicle-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
}

.truck-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.vehicle-text {
  font-weight: 600;
  color: #2c3e50;
  font-size: 13px;
}

.vehicle-total {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 400;
  margin-left: 8px;
}

.driver-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.driver-avatar {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.driver-name {
  font-weight: 500;
  color: #6c757d;
  font-size: 13px;
}

.shift-tag {
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  padding: 4px 8px;
}

.car-count {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.count-circle {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 14px;
}

.count-unit {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
}

.date-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.date-icon {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
}

.date-text {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
}

.status-tag {
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  padding: 4px 8px;
}

.status-tag i {
  margin-right: 4px;
}

.action-buttons {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.edit-btn,
.delete-btn {
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.edit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
}

.edit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.delete-btn {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  border: none;
  color: white;
}

.delete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
}

.pagination-wrapper {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

.custom-pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.custom-pagination >>> .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #667eea;
}

.custom-dialog >>> .el-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.custom-dialog >>> .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 24px;
}

.custom-dialog >>> .el-dialog__title {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
}

.custom-dialog >>> .el-dialog__body {
  padding: 32px;
}

.edit-form >>> .el-form-item__label {
  color: #2c3e50;
  font-weight: 600;
  font-size: 14px;
}

.full-width {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 32px 24px;
}

.cancel-btn {
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  background: #f8f9fa;
  border: 2px solid #e1e8ed;
  color: #6c757d;
}

.save-btn {
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .production-car-container {
    padding: 16px;
  }

  .header-content {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .filter-form {
    flex-direction: column;
    gap: 16px;
  }

  .filter-date,
  .filter-select,
  .filter-input {
    width: 100%;
  }

  .filter-date {
    width: 100%;
  }

  .stats-content {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .stats-icon {
    margin-right: 0;
  }

  .header-actions {
    flex-direction: column;
    gap: 8px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}
</style>
